import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceCondition } from '../../../../../../hooks';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../selectors/analytics';
import { selectCurrentBet } from '../../../../../../selectors/auction';
import { selectBetPosition } from '../../../../../../selectors/betPosition';
import { selectActiveServiceId } from '../../../../../../selectors/publishTerms';
import * as styles from './PackagesLayout.css';
import { trackPackagesLayoutShow } from './tracking';

interface IPackagesLayoutProps {
  betInputLabel: React.ReactNode;
  betInput: React.ReactNode;
  promotion: React.ReactNode;
  promotionCost: React.ReactNode;
  error: React.ReactNode;
}

export const PackagesLayout = ({ betInputLabel, betInput, promotion, promotionCost, error }: IPackagesLayoutProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const activeServiceId = useSelector(selectActiveServiceId)!;
  const betPosition = useSelector(selectBetPosition);
  const bet = useSelector(selectCurrentBet);

  const { offerPosition = null, page = null } = betPosition || {};

  React.useEffect(() => {
    trackPackagesLayoutShow({ analyticsOfferStatus, analyticsProduct, activeServiceId, offerPosition, page, bet });
  }, [activeServiceId, offerPosition, page, bet]);

  return (
    <div className={rootStyle}>
      <div className={styles['auction']}>
        <div className={styles['bet_wrapper']}>
          <div className={styles['input_label']}>{betInputLabel}</div>
          <div className={styles['input']}>{betInput}</div>
          <div className={styles['promotion_cost']}>{promotionCost}</div>
        </div>

        <div className={styles['promotion']}>{promotion}</div>
      </div>

      <div className={styles['error']}>{error}</div>
    </div>
  );
};
